/**
 * Pure-data English catalogue for namespace 'info' (W1-07b formats-package; imports only core/util/types): the
 * manifest diagnostics of info.yml / info.txt / info.csv reading and of the package file resolution, produced by
 * `manifestDiagnosticRef` (resolve.ts). Param `detail` names the field, line, value, encoding or file concerned;
 * 'diag.multipleCharts' also has `chosen`, the chart file that was used.
 */

import type { MessageCatalog } from '../../core/util/types';

const FATAL = 'Phira stops importing the package on this.';

const catalog: MessageCatalog = {
  ns: 'info',
  locale: 'en',
  messages: {
    'diag.quotedNumber': `info.yml writes the number "{detail}" in quotes. ${FATAL} The number was used.`,
    'diag.quotedBool': `info.yml writes the switch "{detail}" in quotes (true or false must be written plain). ${FATAL} The value was used.`,
    'diag.yamlError': `info.yml cannot be read as Phira reads it ({detail}). ${FATAL} Default values were used where needed.`,
    'diag.txtHeader': `info.txt must start with a line that is exactly "#". ${FATAL} The file was read anyway.`,
    'diag.badTxtLine': `This info.txt line has no ": " between key and value: "{detail}". ${FATAL} The line was skipped.`,
    'diag.txtParseFloat': `"{detail}" in the manifest is not a plain number. ${FATAL} The default value was used.`,
    'diag.csvEmpty': `info.csv has no row of values below its header. ${FATAL} Default values were used.`,
    'diag.encodingGuessed':
      'The manifest is not UTF-8 text; it was read as {detail}. Phira detects this too. Exports write UTF-8.',
    'diag.multipleCharts':
      'The package has several chart files ({detail}) and the manifest names none of them that exists. Phira picks one in an unpredictable order and may even take extra.json. "{chosen}" was used: the first file in the package that is a chart (extra.json, phiedit.json and export.json never are). Exports always name the chart.',
    'diag.chartMissing': `No chart file was found (the manifest names "{detail}"). ${FATAL}`,
    'diag.musicMissing':
      'No music file was found (the manifest names "{detail}"). Phira imports the chart but cannot play it.',
  },
};

export default catalog;
